export const comments = [
  {
    id: 1,
    author: "John Doe",
    title: "Lorem ipsum dolor sit amet",
  },
  {
    id: 2,
    author: "Emma Johnson",
    title: "Suspendisse accumsan interdum tellus",
  },
  {
    id: 3,
    author: "John Doe",
    title: "Praesent ultricies ut ipsum",
  },
  {
    id: 4,
    author: "Mark Deen",
    title: "Vivamus malesuada vel nulla vulputate",
  },
  {
    id: 5,
    author: "Sam Brin",
    title: "Aenean auctor egestas auctor",
  },
];
